import React, {Component} from "react";
import {Layout, Form, Input, Button, message} from "antd";

import Header from "../../components/header";
import LeftStu from "../../components/leftStu";
import {reqAvatar ,reqCurrent, reqEditStudent, reqUpload} from "../../api";

import './info.less'

const {Content} = Layout;

/**
 *学生管理路由组件
 */

export class Info extends Component {

    state = {
        user: {}
    };

    getCurrentUser = async () => {
        const result = await reqCurrent();
        this.setState({
            user: result.data
        });
    };

    handleSubmit = e => {
        e.preventDefault();
        const user = this.state.user;
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                // console.log(values)
                const result = await reqEditStudent(user.id, values);
                if (result.code === '000000') {
                    message.success("修改成功");
                    this.getCurrentUser();
                } else {
                    message.error(result.data.msg);
                }
            }
        });
    };

    imgUpload = e => {
        document.getElementById("upload").click();
    };

    handleUpload = async (e) => {
        e.persist();
        let file = e.target.files[0];   //选择的图片文件
        let data = new FormData();
        data.append('file', file);
        const result = await reqUpload(data);
        let datum = new FormData();
        datum.append('avatar', result.data);
        const update = await reqAvatar(datum);
        if(update.code==='000000'){
            message.success("更新成功");
            const current = await reqCurrent();
            this.setState({
                user:current.data
            })
        }
    };

    componentDidMount = async () => {
        sessionStorage.clear();
        this.getCurrentUser();
        document.getElementsByClassName("ant-menu-item")[1].click();
    };

    render() {

        const {getFieldDecorator} = this.props.form;
        const {user} = this.state;

        return (
            <Layout>
                <Header>Header</Header>
                <Layout>
                    <LeftStu>LeftStu</LeftStu>
                    <Content>
                        <div className='info_box'>
                            <div className='info_head'>
                                <Input name="file" accept="image/*" id="upload" type="file"
                                       onChange={this.handleUpload.bind(this)} style={{opacity: 0}}/>
                                <img className='upload' src={this.state.user.avatar?global.constant.uploadImage + this.state.user.avatar:require("../../assets/images/head.png")}
                                     onClick={this.imgUpload}/>
                                <span>{user.name}</span>
                            </div>
                            <div className='info_body'>
                                <Form onSubmit={this.handleSubmit}>
                                    <Form.Item label="姓名">
                                        {getFieldDecorator('name', {initialValue: user.name})(<span
                                            className="ant-form-text">{user.name}</span>)}
                                    </Form.Item>
                                    <Form.Item label="用户名" hidden>
                                        {getFieldDecorator('userName', {initialValue: user.userName})(<span
                                            className="ant-form-text">{user.name}</span>)}
                                    </Form.Item>
                                    <Form.Item label="密码" hidden>
                                        {getFieldDecorator('password', {initialValue: user.name})(<span
                                            className="ant-form-text">{user.password}</span>)}
                                    </Form.Item>
                                    <Form.Item label="状态" hidden>
                                        {getFieldDecorator('status', {initialValue: user.status})(<span
                                            className="ant-form-text">{user.status}</span>)}
                                    </Form.Item>
                                    <Form.Item label="班级Id" hidden>
                                        {getFieldDecorator('classRoomId', {initialValue: user.classRoomId})(<span
                                            className="ant-form-text">{user.classRoomId}</span>)}
                                    </Form.Item>
                                    <Form.Item label="班级">
                                        {getFieldDecorator('classRoomName', {initialValue: user.classRoomName})(<span
                                            className="ant-form-text">{user.classRoomName}</span>)}
                                    </Form.Item>
                                    <Form.Item label="手机号" className="phone">
                                        {getFieldDecorator('mobile', {
                                            validate: [
                                                // 在onBlur时，触发两个对象中的规则
                                                {
                                                    trigger: "onBlur",
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message: '请输入手机号'
                                                        }, {
                                                            pattern: /^1[3|4|5|7|8][0-9]\d{8}$/,
                                                            message: '请输入正确的手机号'
                                                        }
                                                    ],
                                                },
                                            ],
                                            initialValue: user.mobile
                                        })(<Input className='info_input' autoComplete={"off"}/>)}
                                    </Form.Item>
                                    <Form.Item label="邮箱">
                                        {getFieldDecorator('email', {
                                            validate: [
                                                // 在onBlur时，触发两个对象中的规则
                                                {
                                                    trigger: "onBlur",
                                                    rules: [
                                                        {
                                                            type: 'email',
                                                            message: '邮箱格式错误',
                                                        },
                                                        {
                                                            required: true,
                                                            message: '请输入邮箱',
                                                        },
                                                    ],
                                                },
                                            ],
                                            initialValue: user.email
                                        })(<Input className='info_input' autoComplete={"off"}/>)}
                                    </Form.Item>
                                    <Form.Item>
                                        <Button type="primary" htmlType="submit" className='save'>
                                            保存
                                        </Button>
                                    </Form.Item>
                                </Form>
                            </div>
                        </div>
                    </Content>
                </Layout>
            </Layout>
        )
    }
}

const WrappedInfo = Form.create()(Info);
export default WrappedInfo;